module.exports = __webpack_public_path__ + "static/media/tallyfy-thumbnail.b1fcb6ba.jpg";